import * as Yup from "yup";

Yup.addMethod(Yup.string, "onlyNumbers", function () {
  return this.matches(/^\d+$/, "O campo deve ser numerico");
});

export default Yup;
